import {validatePhoneNumber, validateRequired} from "./ValidationFunctions";

export const subDepartmentsConfig = {
  fields: {
    name: {
      type: 'text',
      label: 'Name of division',
      rules: [validateRequired('Division name')]
    },
    phoneNumber: {
      type: 'text',
      label: 'Phone number',
      rules: [validateRequired('Phone number'), validatePhoneNumber]
    }
  }
};